import { AccountBase } from '@/models/AccountViewModel';
import {
  AccountTypeNumber,
  WealthAccountTransactionTypeIdNumber,
} from './enums';

export const AccountBaseUtility = () => {
  const isOffline = (account: AccountBase) => {
    return account.AccountType === AccountTypeNumber.MANUALLY_ENTERED;
  };

  const isAllocation = (account: AccountBase) => {
    return (
      account.AccountType === AccountTypeNumber.ESTATE ||
      account.AccountType === AccountTypeNumber.ENTITY
    );
  };

  const isClosed = (account: AccountBase) => {
    return !!account.ClosedDate;
  };

  const isBanking = (account: AccountBase) => {
    return (
      account.TransactionTypeId ===
      WealthAccountTransactionTypeIdNumber.CASH_FLOW
    );
  };

  return { isOffline, isAllocation, isClosed, isBanking };
};

export default AccountBaseUtility();
